exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "html{position:relative;min-height:100%}@media (min-width:768px){body{margin-bottom:80px!important}}.footer{width:100%;padding-right:80px;min-height:50px;background-color:#0c2c3c;color:#fff;line-height:50px}@media (min-width:768px){.footer{position:absolute;bottom:0}}body>.container{padding:60px 15px 0}.footer>.container{padding-right:15px;padding-left:15px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/autoprefixer-loader?browsers=last 2 version!./~/sass-loader?sourceMap&includePaths[]=/tmp/ppa-firebase/src/styles!./src/views/footer.scss
// module id = 1298
// module chunks = 2